export const stateName = 'location' as const
